//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: "AppPagination",
  props: ["currentPage", "enableNext", "navigate"],
  components: {},
  data() {
    return {};
  },
  computed: {
		...mapGetters([
			"siteName"
		]),
	},
  methods: {},
  created() { },
  mounted() { },
};
